import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { GoogleLinkService } from 'src/app/services/google-link.service';

@Component({
  selector: 'app-social-sign-in-test',
  templateUrl: './social-sign-in-test.component.html',
  styleUrls: ['./social-sign-in-test.component.scss'],
})
export class SocialSignInTestComponent {
  googleLoading = false;
  googleError = '';
  googleResultJson = '';

  constructor(
    private readonly googleLink: GoogleLinkService,
    private readonly dataService: DataService
  ) {}

  get googleConfigured(): boolean {
    return this.googleLink.isConfigured;
  }

  async continueWithGoogle(): Promise<void> {
    if (!this.googleConfigured) {
      this.googleError =
        'googleOAuthClientId is missing in environment (Google OAuth Web client).';
      return;
    }
    this.googleLoading = true;
    this.googleError = '';
    this.googleResultJson = '';
    try {
      const code = await this.googleLink.requestAuthCode();
      const result = await firstValueFrom(
        this.dataService.post('api/v1/auth/identity/test/google-sign-in', {
          code,
          redirectUri: 'postmessage',
        })
      );
      this.googleResultJson = JSON.stringify(result, null, 2);
    } catch (err: unknown) {
      const msg =
        (err as { error?: { message?: string } })?.error?.message ||
        (err instanceof Error ? err.message : 'Google sign-in failed.');
      this.googleError = msg;
    } finally {
      this.googleLoading = false;
    }
  }
}
